import { render, staticRenderFns } from "./propertyItem.vue?vue&type=template&id=8f339b2c&"
import script from "./propertyItem.vue?vue&type=script&lang=js&"
export * from "./propertyItem.vue?vue&type=script&lang=js&"
import style0 from "./propertyItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports